// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__npVVh","key":"Card_key__ff93m","data":"Card_data__WnHNZ"};